/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Checkbox } from '@americanexpress/dls-react';
import { FxFormItem } from './FxFormItem';
import { getFieldStatus, getFieldErrorMessage } from '../../../utils/formUtils';

export const FxCheckboxField = ({
  id,
  label,
  checkboxLabel,
  isRequired,
  className,
  isChecked,
  canExecuteFieldOnChange,
  showError,
  input: {
 value, onChange, onBlur, onFocus,
},
  meta,
  handleOnChange = () => {},
  handleOnBlur = () => {},
  handleOnFocus = () => {},
  type,
  ...restProps
}) => {
  const status = getFieldStatus(meta, null);
  const errorMessage = getFieldErrorMessage(meta, status);

  return (
    <FxFormItem
      id={id}
      label={label}
      className={className}
      isRequired={isRequired}
      status={status}
      errorMessage={errorMessage}
      showError={showError}
      {...restProps}
    >
      <Checkbox
        id={id}
        value={value}
        checked={isChecked}
        label={checkboxLabel}
        status={status}
        describedBy={id}
        type={type}
        onChange={(e) => {
          if (canExecuteFieldOnChange) onChange(e);
          handleOnChange(e);
        }}
        onBlur={(e) => {
          onBlur(e);
          handleOnBlur(e);
        }}
        onFocus={(e) => {
          onFocus(e);
          handleOnFocus(e);
        }}
        {...restProps}
      />
    </FxFormItem>
  );
};

export default FxCheckboxField;

FxCheckboxField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  checkboxLabel: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  className: PropTypes.string,
  isChecked: PropTypes.bool.isRequired,
  canExecuteFieldOnChange: PropTypes.bool,
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
  }).isRequired,
  meta: PropTypes.shape({}).isRequired,
  handleOnChange: PropTypes.func,
  handleOnBlur: PropTypes.func,
  handleOnFocus: PropTypes.func,
  type: PropTypes.string,
  showError: PropTypes.bool,
};

FxCheckboxField.defaultProps = {
  label: null,
  isRequired: false,
  className: null,
  canExecuteFieldOnChange: true,
  handleOnChange: () => {},
  handleOnBlur: () => {},
  handleOnFocus: () => {},
  type: 'checkbox',
  showError: true,
};
